/*
 * Copyright 2022 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useOutlet } from 'react-router-dom';
import { DefaultDevToolsPage } from '../DefaultDevToolsPage';
import { ReactElement } from 'react';

/**
  @public
 */
export interface DevToolsPageProps {
  contents?: DevToolsPageContent[];
}

/**
  @public
 */
export interface DevToolsPageContent {
  title: string;
  path: string;
  children: ReactElement;
}

export const DevToolsPage = ({ contents }: DevToolsPageProps) => {
  const outlet = useOutlet();

  return <>{outlet || <DefaultDevToolsPage contents={contents} />}</>;
};
